<ng-container *transloco="let t;read: 'workers'">

  <div class="norecordfound-block text-center py-4 text-muted">
    <i class="fa-regular fa-face-frown fs-3 mb-2"></i>
    <h4 class="text-900 font-bold text-3xl lg:text-5xl mb-2"> {{ t('addWorkers.noRecordsFound') }}
    </h4>
  </div>
</ng-container>